import { findSwipersInBlocks } from '../parts/ui';

jQuery(document).ready(function () {
    const block = $('.mainbanner-block');
    if (!block.get(0)) return;
    findSwipersInBlocks('.mainbanner-block', {
        slidesPerView: 1,
        spaceBetween: 30,
        autoplay: {
            delay: 7000,
            pauseOnMouseEnter: true
        },
        pagination: {
            renderBullet: function (index, className) {
                return '<span class="' + className + '"><span></span></span>';
            }
        },
        on: {
            autoplayTimeLeft: (swiper, timeLeft, percentage) => {
                jQuery('.mainbanner-block .swiper-pagination-bullet-active span').width(
                    Math.ceil(100 * percentage) + '%'
                );
            }
        }
    });
});
